<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosBolsa from './compartilhado/FormDadosBolsa.vue';
  import CronogramaParcelas from './compartilhado/FormCronogramaParcelas.vue';
  import DadosTermoAditivo from './compartilhado/FormDadosTermoAditivo.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import ArquivoBolsa from './compartilhado/FormArquivoBolsa.vue';
  import solicitacaoBolsaServico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import formatarData from '~js/formatar-data';
  import Termo from './compartilhado/FormTermo.vue';
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';

  export default {
    components: { DadosCadastrais, checkbox, Radio, DadosBolsa, CronogramaParcelas, DadosTermoAditivo, DadosBancarios, AdicionarArquivos, ListaDeArquivos, ArquivoBolsa, Termo },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        dadosBancariosPIX: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        arquivosBolsas: [],
        bolsas: [],
        tiposContrato: [],
        subTiposContrato: [],
        contratosTermoAditivo: [],
        desabilitarBeneficiario: false,
        erroArquivos: false,
        usarEstruturaArquivoAntiga: false,
        pertenceQuadroOriginal: false,
        parcelas: [],
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `${'Solicitação de ' + this.configuracao.nomeModuloSolContratos} - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-bolsa.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.cpfCnpj)
          return false;

        return pessoaServico
          .busca(this.solicitacao.cpfCnpj)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
          });
      },

      buscarBeneficiario() {
        $('#avancar').button('loading');

        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');

            this.solicitacao.cpfCnpj = pessoa.cpfCnpj;
            this.solicitacao.nome = pessoa.nomePessoaFisicaJuridica;
            this.solicitacao.nomeSocial = pessoa.nomeSocial;
            this.solicitacao.endereco = pessoa.endereco ? pessoa.endereco.substring(0, 100) : pessoa.endereco;
            this.solicitacao.numero = pessoa.numero ? pessoa.numero.substring(0, 10) : pessoa.numero;
            this.solicitacao.complemento = pessoa.complemento ? pessoa.complemento.substring(0, 80) : pessoa.complemento;
            this.solicitacao.bairro = pessoa.bairro ? pessoa.bairro.substring(0, 80) : pessoa.bairro;
            this.solicitacao.cidade = pessoa.cidade ? pessoa.cidade.substring(0, 60) : pessoa.cidade;
            this.solicitacao.uf = pessoa.estado;
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.telefone1 = pessoa.telefone1;
            this.solicitacao.telefone2 = pessoa.telefone2;
            this.solicitacao.email = pessoa.email;

            this.solicitacao.inss = pessoa.inss;
            this.solicitacao.pisPasep = pessoa.pisPasep;

            this.solicitacao.matricula = pessoa.matriculaPessoa;
            this.solicitacao.siafi = pessoa.siafi;
            
            this.solicitacao.pertenceQuadro = (pessoa.tipoQuadro > 0);
            this.pertenceQuadroOriginal = (pessoa.tipoQuadro > 0); 

            if (pessoa.tipoQuadro > 0)
              this.solicitacao.tipoQuadro = pessoa.tipoQuadro;
            else
              this.solicitacao.tipoQuadro = null;

            if (this.solicitacao.inss) {
              this.solicitacao.inss = this.solicitacao.inss.replace('   .     .  / ', "");
            }

            if (this.solicitacao.pisPasep) {
              this.solicitacao.pisPasep = this.solicitacao.pisPasep.replace('   .     .  / ', "");
            }

            this.solicitacao.identidade = pessoa.identidadeInscEstadual;
            this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
            this.dadosBancarios = pessoa.dadosBancarios;
            this.dadosBancariosPIX = pessoa.dadosBancariosPIX;

            this.solicitacao.cargo = pessoa.cargo;
            this.solicitacao.departamento = pessoa.departamento;
            this.solicitacao.cnpjInstituicaoPublica = pessoa.cnpjInstituicaoPublica;
            this.solicitacao.instituicaoPublica = pessoa.instituicaoPublica;
            this.solicitacao.cargaHorariaInstituicao = pessoa.cargaHorariaInstituicao;
            this.solicitacao.unidade = pessoa.unidade;
            this.solicitacao.tipoQuadroUSP = pessoa.tipoQuadroUSP;
            this.solicitacao.regimeTrabalhoUSP = pessoa.regimeTrabalho;

            if (pessoa.funcionarioPublico != null) {
              if (pessoa.funcionarioPublico == true)
                this.solicitacao.funcionarioPublico = 1;

              if (pessoa.funcionarioPublico == false)
                this.solicitacao.funcionarioPublico = 0;
            }

            if (pessoa.pertenceQuadroUSP != null) {
              if (pessoa.pertenceQuadroUSP == true)
                this.solicitacao.pertenceQuadroUSP = 1;

              if (pessoa.pertenceQuadroUSP == false)
                this.solicitacao.pertenceQuadroUSP = 0;
            }

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();

            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.cpfCnpj = this.documento;

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
          });
      },

      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .then(this.carregarTiposContrato)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      fusp() {
         return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
      cronogramaHabilitado() {
        return this.configuracao.habilitarCronogramaAdicionalVariavel === true;
      },
      tipoTodasSolicitacoesFUSP() {
        //return false;

        if (!this.fusp())
            return false;

        if (this.solicitacao.tipoBolsa !== 4) {
            return true;
        }
      },
      validarFuncionarioSelecionado(valido) {
        if (!valido) throw new Error("validacao com erro");

        //return this.$validator.validateAll();

        if (this.tipoTodasSolicitacoesFUSP() == false)
          return this.$validator.validateAll();

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.funcionarioPublico == 1) || (this.solicitacao.funcionarioPublico == 0))) {
          validou = false;
        }
      
        if (!validou) msgErro = `É necessário informar se é funcionário público.`

        if (msgErro) {
          $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );
          
          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      validarPertenceQuadroUSPSelecionado(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.tipoTodasSolicitacoesFUSP() == false)
          return this.$validator.validateAll();

        if (this.solicitacao.funcionarioPublico == 0)
          return this.$validator.validateAll();

        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return this.$validator.validateAll();

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.pertenceQuadroUSP == 1) || (this.solicitacao.pertenceQuadroUSP == 0))) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário informar se pertence ao quadro de funcionários da USP.`

        if (msgErro) {
          $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );
          
          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      salvar() {
        $('#salvar').button('loading');
        var ObrigatorioPISPASEPINSSWeb = this.configuracao.obrigatorioPisPasepInssWebs

        if (this.solicitacao.tipoBolsa != "4") {
          this.$refs.dadosCadastrais
            .validar()
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
            .then(valido => {
              if (ObrigatorioPISPASEPINSSWeb) {
                if (this.solicitacao.pisPasep === '' && this.solicitacao.inss === '') {
                  this.$swal('', 'Preencha o PIS/PASEP ou o INSS.', 'info');
                  $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                  throw new Error("validacao");
                }
              }

              return valido;
            })
            .then(valido => {
              if (ObrigatorioPISPASEPINSSWeb) {
                if (this.solicitacao.pisPasep === '' && this.solicitacao.inss === '') {
                  this.$swal('', 'O PIS/PASEP não pode ser igual ao INSS.', 'info');
                  $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                  throw new Error("validacao");
                }
              }

              return valido;
            })
            .then(this.validarFuncionarioSelecionado)
            .then(this.validarPertenceQuadroUSPSelecionado)
            .then(this.$refs.dadosBolsa.validar)
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-bolsa"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
            .then(this.validarDataVigencia)
            .then(this.validarCronograma)
            .then(this.$refs.dadosBancarios.validar)
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
            .then(this.validarTermoResponsabilidade)
            .then(this.validarAnexos)
            .then(this.validarArquivos)
            .then(valido => {
              if (!valido) {
                this.erroArquivos = true;
                this.usarEstruturaArquivoAntiga 
                  ? $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show')
                  : $('#tabs a[href="#tab-arquivo-bolsa"]').tab('show');
              }

              return valido;
            })
            .then(this.enviar)
            .then(id => {
              this.$imprimirRelatorio('solicitacao-bolsa.relatorio', id, 'solicitacao-bolsa');
            })
            .catch(this.tratarErroSalvar);
        } else {
          this.$refs.dadosCadastrais
            .validar()
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
            .then(this.$refs.dadosTermoAditivo.validar)
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-ta"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
            .then(this.$refs.dadosBancarios.validar)
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
            .then(this.validarArquivos)
            .then(valido => {
              if (!valido) {
                this.erroArquivos = true;
                this.usarEstruturaArquivoAntiga
                  ? $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show')
                  : $('#tabs a[href="#tab-arquivo-bolsa"]').tab('show');
              }

              return valido;
            })          
            .then(this.enviar)
            .then(id => {
              this.$imprimirRelatorio('solicitacao-bolsa.relatorio', id, 'solicitacao-bolsa');
            })
            .catch(this.tratarErroSalvar);
        }
      },

      tratarErroSalvar(erro) {
        $('#salvar').button('reset');

        if (this.erroArquivos) {
          this.erroArquivos = false;
          return;
        }

        if (erro && erro.status === 422 && Array.isArray(erro.body) && erro.body.length > 0) {
          const mensagens = erro.body
            .map(item => item && (item.mensagem || item.errorMessage))
            .filter(mensagem => !!mensagem);

          if (mensagens.length > 0) {
            if (erro.body.some(item => item && item.propriedade === 'Parcelas'))
              $('#tabs a[href="#tab-cronograma"]').tab('show');

            this.$swal({
              title: '',
              html: mensagens.map(mensagem => $('<div>').text(mensagem).html()).join('<br>'),
              type: 'warning'
            });

            return;
          }
        }

        this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
      },

      validarCronograma(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.exibirCronograma)
          return valido;

        const erro = mensagem => {
          $('#tabs a[href="#tab-cronograma"]').tab('show');
          this.$swal('', mensagem, 'info');
          throw new Error("validacao");
        };

        if (this.parcelas.length === 0)
          erro('Informe o cronograma de parcelas do adicional variável. Use o botão "Gerar cronograma".');

        if (this.$refs.cronograma.desatualizado)
          erro('O projeto, a vigência ou o valor mensal mudaram depois que o cronograma foi montado. Clique em "Gerar cronograma" para refazer as parcelas antes de salvar.');

        if (this.$refs.cronograma.cronogramaAceito === null)
          erro('Responda se você aceita o cronograma: use "Aceito o cronograma" ou "Ajustar as parcelas" no rodapé da aba.');

        for (let indice = 0; indice < this.parcelas.length; indice++) {
          const parcela = this.parcelas[indice];
          const rotulo = `Parcela ${indice + 1}`;

          if (!moment(parcela.dataParcelaTexto, 'DD/MM/YYYY').isValid())
            erro(`${rotulo}: data de pagamento inválida. Clique em "Gerar cronograma" para refazer o cronograma.`);

          const valor = (parcela.valorParcela || '').toString().replace(/[^0-9]/g, '');

          if (!valor || +valor === 0)
            erro(`${rotulo}: informe um valor maior que zero.`);
        }

        return valido;
      },

      validarDataVigencia(valido) {
        if (!valido) throw new Error("validacao com erro");

        let dataVigenciaInicio = moment(this.solicitacao.dataVigenciaInicio, 'DD/MM/YYYY');
        let dataVigenciaFim = moment(this.solicitacao.dataVigenciaFim, 'DD/MM/YYYY');

        if (!dataVigenciaInicio.isSameOrBefore(dataVigenciaFim)) {
          $('#tabs a[href="#tab-dados-bolsa"]').tab('show');

          this.$swal(
            '',
            'A data início de vigência deve ser anterior ou igual a data de fim da vigência.',
            'info'
          );

          throw new Error("validacao");
        }

        if (this.solicitacao.projeto.dataInicio > 0) {
          let dataInicioProjeto = moment(formatarData.paraData(this.solicitacao.projeto.dataInicio), 'DD/MM/YYYY');

          if (!dataVigenciaInicio.isSameOrAfter(dataInicioProjeto)) {
            $('#tabs a[href="#tab-dados-bolsa"]').tab('show');

            this.$swal(
              '',
              'A data início de vigência deve ser posterior ou igual a data de início execução do projeto ' + dataInicioProjeto._i,
              'info'
            );

            throw new Error("validacao");
          }

          if (!dataVigenciaFim.isSameOrAfter(dataInicioProjeto)) {
            $('#tabs a[href="#tab-dados-bolsa"]').tab('show');

            this.$swal(
              '',
              'A data fim de vigência deve ser posterior ou igual a data de início execução do projeto ' + dataInicioProjeto._i,
              'info'
            );

            throw new Error("validacao");
          }         
        }

        if (this.solicitacao.projeto.dataTermino > 0) {
          let dataFimProjeto = moment(formatarData.paraData(this.solicitacao.projeto.dataTermino), 'DD/MM/YYYY');

          if (!dataVigenciaInicio.isSameOrBefore(dataFimProjeto)) {
            $('#tabs a[href="#tab-dados-bolsa"]').tab('show');

            this.$swal(
              '',
              'A data início de vigência deve ser anterior ou igual a data de término execução do projeto ' + dataFimProjeto._i,
              'info'
            );

            throw new Error("validacao");
          }

          if (!dataVigenciaFim.isSameOrBefore(dataFimProjeto)) {
            $('#tabs a[href="#tab-dados-bolsa"]').tab('show');

            this.$swal(
              '',
              'A data fim de vigência deve ser anterior ou igual a data de término execução do projeto ' + dataFimProjeto._i,
              'info'
            );

            throw new Error("validacao");
          }
        }

        return valido;
      },

      validarArquivos() {
        if (this.usarEstruturaArquivoAntiga) {
          if (this.configuracao.obrigatorioArquivoSolBolsa) {
            const faltaArquivo = !this.$refs.adicionarArquivos.existeArquivo();

            if (this.arquivos.length === 0 && faltaArquivo) {
              var texto = "Adicione pelo menos um arquivo na solicitação! <br>";

              this.$swal({
                title: 'Falta de Arquivos',
                html: texto,
                type: 'error',
                confirmButtonText: 'Ok, entendi!',
                allowOutsideClick: false,
                allowEscapeKey: false,
              });

              return false;
            }
          }
        } else {
          if (!this.$refs.arquivosBolsa.validarArquivoPendente()) {
            var texto = "Arquivo foi selecionado mas não foi adicionado na lista de arquivo! <br>"
              + "Por favor, adicione o arquivo ou remova-o do campo de seleção.";

            this.$swal({
              title: 'Arquivo não adicionado à listagem',
              html: texto,
              type: 'error',
              confirmButtonText: 'Ok, entendi!',
              allowOutsideClick: false,
              allowEscapeKey: false,
            });

            return false;
          }
          if (!this.$refs.arquivosBolsa.validarArquivosObrigatorios(this.solicitacao.solicitacaoAnexouArquivo == 'true')) {

            var texto = this.$refs.arquivosBolsa.tipoArquivoPadrao == 0
              ? "Adicione todos os arquivos obrigatórios de Bolsa! <br>"
              : "Adicione pelo menos um arquivo na solicitação! <br";

            this.$swal({
              title: 'Falta de Arquivos',
              html: texto,
              type: 'error',
              confirmButtonText: 'Ok, entendi!',
              allowOutsideClick: false,
              allowEscapeKey: false,
            });

            return false;
          }
        }
        return true;
      },

      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        if (this.exibirCronograma) {
          copiaSolicitacao.parcelas = JSON.parse(JSON.stringify(this.parcelas));
        }

        if (this.$route.params.id) {

          if (!this.usarEstruturaArquivoAntiga) {
            copiaSolicitacao.arquivosDeletados = this.$refs.arquivosBolsa.arquivosDeletados;
            return solicitacaoBolsaServico.alterar(copiaSolicitacao, this.bolsas, this.arquivosBolsas, this.$route.params.id);
          }
          copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
          return solicitacaoBolsaServico.alterar(copiaSolicitacao, null, this.$refs.adicionarArquivos.arquivos, this.$route.params.id);

        } else {

          if (!this.usarEstruturaArquivoAntiga) {
            copiaSolicitacao.arquivosDeletados = this.$refs.arquivosBolsa.arquivosDeletados;
            return solicitacaoBolsaServico.adicionar(copiaSolicitacao, this.bolsas, this.arquivosBolsas);
          }
          copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
          return solicitacaoBolsaServico.adicionar(copiaSolicitacao, null, this.$refs.adicionarArquivos.arquivos);
        }
      },

      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolBolsa || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolBolsa.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },

      camposSolicitacao() {
        return {
          idSolicitacaoBolsa: null,
          idCoordenador: null,
          idProjeto: null,
          tipoBolsa: 1,
          competenciaProvisao: 1,
          nome: null,
          nomeSocial: null,
          cpfCnpj: '',
          observacao: null,
          agencia: null,
          banco: null,
          conta: null,
          tipoConta: '',
          tipoPix: '',
          chavePix: '',
          valorContrato: null,
          dataNascimento: '',
          identidade: null,
          inss: null,
          pisPasep: null,
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          cep: null,
          uf: '',
          telefone1: null,
          telefone2: null,
          email: null,
          matricula: '',
          siafi: '',
          dataVigenciaInicio: '',
          dataVigenciaFim: '',
          idTipoContrato: '',
          idSubTipoContrato: '',
          dataTermoAditivoTa: '',
          dataVigenciaInicioTa: '',
          dataVigenciaTerminoTa: '',
          tipoPlanoTrabalho: '',
          tipoTermoContratual: '',
          tipoPrazo: '',
          dias: '',
          tipoValor: '',
          valortermo: '',
          descricaoObjetoTa: '',
          observacaoTa: '',
          cargaHoraria: '',
          idContratoTermoAditivo: 0,
          cursoDoContratado: '',
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          },
          pertenceQuadro: false,
          tipoQuadro: '',
          funcionarioPublico: null,
          pertenceQuadroUSP: null,
          tipoQuadroUSP: null,
          regimeTrabalhoUSP: null,
          cargo: null,
          departamento: null,
          unidade: null,
          instituicaoPublica: null,
          cnpjInstituicaoPublica: null,
          cargaHorariaInstituicao: null,
          solicitacaoAnexouArquivo: null,
          solicitacaoJustificativaAnexo: null,
          aceite: ''
        };
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;
        let idProjeto = null;

        solicitacaoBolsaServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;

            idProjeto = solicitacao.idProjeto;
            solicitacao.idTipoContrato = solicitacao.idTipoContrato || '';
            solicitacao.idSubTipoContrato = solicitacao.idSubTipoContrato || '';
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.cpfCnpj);
          })
          .then(() => {
            return this.carregarDadosBancariosPIX(solicitacao.cpfCnpj);
          })
          .then(() => {
            this.solicitacao.idTipoContrato = solicitacao.idTipoContrato;

            return this.$refs.dadosBolsa.carregarSubTiposContrato();
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.projeto.utilizarRubricaSubrubricaWeb) {
              return this.$refs.dadosCadastrais.listaDeRubricas(idProjeto);
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.projeto.utilizarRubricaSubrubricaWeb) {
              return this.$refs.dadosCadastrais.listaDeSubrubricas(idProjeto, solicitacao.idRubrica);
            }
          })
          .then(() => {
            if (!this.exibirCronograma) return;

            return solicitacaoBolsaServico.parcelas(id).then(parcelas => {
              this.parcelas = parcelas;
            });
          })
          .then(() => solicitacaoBolsaServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.$refs.dadosBancarios.setarTipoBancario(parseInt(solicitacao.tipoConta));
            this.buscaDesabilitarBeneficiario();
            this.carregando = false;
          }).then(() => {
            this.carregarBolsaArquivo(id);
          });
      },

      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarDadosBancariosPIX(cpf) {
        return pessoaServico
          .dadosBancariosPIX(cpf)
          .then(dadosBancarios => {
            this.dadosBancariosPIX = dadosBancarios;
          })
      },
      carregarBolsaArquivo(idSolicitacaoBolsa) {
        return solicitacaoBolsaServico.carregarSolicitacaoBolsaArquivo(idSolicitacaoBolsa)
          .then(bolsaArquivo => {
            this.bolsas = bolsaArquivo;
            this.usarEstruturaArquivoAntiga = this.arquivos.length > this.bolsas.length;
          })
      },

      download(arquivo) {
        solicitacaoBolsaServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },

      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },

      carregaTiposContrato() {
        if (this.solicitacao.tipoBolsa == "4")
          return;

        this.$refs.dadosBolsa.carregarTiposContrato();
      },
      carregarContratosTermoAditivo() {
        if (this.solicitacao.tipoBolsa != "4")
          return;

        if (this.solicitacao.idProjeto == null)
          return;

        if (this.solicitacao.idProjeto == 0)
          return;

        this.$refs.dadosTermoAditivo.carregarContratosTermoAditivo(this.solicitacao.cpfCnpj);
      },
      limparPertenceQuadro() {
        if (!this.solicitacao.pertenceQuadro) {
          this.solicitacao.tipoQuadro = '';
        }
      },
      limparAnexouArquivo() {
        if (this.solicitacao.solicitacaoAnexouArquivo == 'true') {
          this.solicitacao.solicitacaoJustificativaAnexo = null;
        }
      },
        validarTermoResponsabilidade(valido) {
            if (!valido) throw new Error("validacao com erro");

            if (!this.habilitarOuDesabilitarTermo) return true;

            if (this.solicitacao.aceite) return true;

            $('#tabs a[href="#tab-termo"]').tab('show');

            this.$refs.termo.adicionaErroAceite();

            throw new Error("validacao");
        },
      validarAnexos(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.anexarCERT)
          return true;

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.solicitacaoAnexouArquivo == 'true') || (this.solicitacao.solicitacaoAnexouArquivo == 'false'))) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário informar se anexou a CERT.`

        if (msgErro) {
          $('#tabs a[href="#tab-arquivo-bolsa"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
    },
    created() {
      if (this.$route.params.id) {
        this.carregar(this.$route.params.id);
        this.$set(this, 'mostrarFormulario', true);
      }
    },
    computed: {
      exibirCronograma() {
        return this.cronogramaHabilitado() && this.fusp() && this.solicitacao.tipoBolsa == 5;
      },
      anexarCERTAviso() {
        return (this.solicitacao.tipoBolsa == 2) && this.solicitacao.regimeTrabalhoUSP == 1;
      },
      anexarCERT() {
        return false;
        return (this.solicitacao.tipoBolsa == 2) && this.solicitacao.regimeTrabalhoUSP == 1;
      },
      habilitarOuDesabilitarTermo() {
        if (!this.tipoTodasSolicitacoesFUSP())
            return false;

        return this.solicitacao.funcionarioPublico == 0 && this.fusp();
      },
      nomeTipoSolicitacao() {
        switch (this.solicitacao.tipoBolsa) {
          case 1: return "bolsa";
            break;
          case 2: return "RPA";
            break;
          case 3: return "estágio";
            break;
          case 4: return "termo aditivo";
            break;
          case 5: return "adicional variável";
            break;
          default: return "";
            break;
        }
      }
    },
    watch: {
      'solicitacao.tipoBolsa': 'carregaTiposContrato',
      'solicitacao.idProjeto': 'carregarContratosTermoAditivo',
      'solicitacao.pertenceQuadro': 'limparPertenceQuadro',
      'solicitacao.solicitacaoAnexouArquivo': 'limparAnexouArquivo',
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Dados cadastrais
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   v-if="solicitacao.tipoBolsa != 4"
                   href="#tab-dados-bolsa">
                  Dados do contrato
                </a>
              </li>
              <li v-if="exibirCronograma">
                <a data-toggle="tab"
                   href="#tab-cronograma">
                  Cronograma de parcelas
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   v-if="solicitacao.tipoBolsa == 4"
                   href="#tab-dados-ta">
                  Termo aditivo
                </a>
              </li>
              <li>
                <a @click.prevent=""
                   data-toggle="tab"
                   href="#tab-dados-bancarios">
                  Dados bancários
                </a>
              </li>
              <li v-if="habilitarOuDesabilitarTermo">
                <a data-toggle="tab"
                   href="#tab-termo">
                  Termo de consentimento
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoBolsa && !usarEstruturaArquivoAntiga">
                <a @click.prevent=""
                   data-toggle="tab"
                   href="#tab-arquivo-bolsa">
                  Arquivos {{ nomeTipoSolicitacao }}
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoBolsa && usarEstruturaArquivoAntiga">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoBolsa && usarEstruturaArquivoAntiga">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :solicitacao="solicitacao"
                                    :desabilitarBeneficiario="this.desabilitarBeneficiario"
                                    :pertenceQuadroOriginal="this.pertenceQuadroOriginal"
                                    :carregando.sync="carregando"
                                    :edicao="!!$route.params.id">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-dados-bolsa" class="tab-pane" v-if="solicitacao.tipoBolsa != 4">
                <div class="panel-body">
                  <dados-bolsa ref="dadosBolsa"
                               :solicitacao="solicitacao"
                               :edicao="!!$route.params.id"
                               :tipos-contrato="tiposContrato"
                               :sub-tipos-contrato="subTiposContrato">
                  </dados-bolsa>
                </div>
              </div>

              <div id="tab-cronograma" class="tab-pane" v-if="exibirCronograma">
                <div class="panel-body">
                  <cronograma-parcelas ref="cronograma"
                                       :solicitacao="solicitacao"
                                       :parcelas.sync="parcelas">
                  </cronograma-parcelas>
                </div>
              </div>

              <div id="tab-dados-ta" class="tab-pane" v-if="solicitacao.tipoBolsa == 4">
                <div class="panel-body">
                  <dados-termo-aditivo ref="dadosTermoAditivo"
                                       :solicitacao="solicitacao"
                                       :edicao="!!$route.params.id">
                  </dados-termo-aditivo>
                </div>
              </div>

              <div id="tab-dados-bancarios" class="tab-pane">
                <div class="panel-body">
                  <dados-bancarios ref="dadosBancarios"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id"
                                   :dadosBancarios="dadosBancarios"
                                   :dadosBancariosPIX="dadosBancariosPIX">
                  </dados-bancarios>
                </div>
              </div>

              <div id="tab-termo" class="tab-pane" v-if="habilitarOuDesabilitarTermo">
                  <div class="panel-body">
                      <termo :solicitacao.sync="solicitacao"
                             ref="termo">
                      </termo>
                  </div>
              </div>

              <div id="tab-arquivo-bolsa" class="tab-pane" v-if="!usarEstruturaArquivoAntiga">
                <div class="panel-body">
                    <div class="alert alert-warning" role="alert" v-if="anexarCERTAviso">
                        <div class="table-responsive">
                            Quando o regime do docente for RDIDP, será necessário anexar o documento CERT atualizado.
                        </div>
                    </div>

                    <arquivo-bolsa ref="arquivosBolsa"
                                   :bolsas="bolsas"
                                   :solicitacao="solicitacao"
                                   :arquivosBolsas="arquivosBolsas">
                    </arquivo-bolsa>

                    <div v-if="anexarCERT">
                      <div class="hr-line-dashed"></div>

                      <h3 class="m-t-none m-b margin-top-5">Arquivos anexados:</h3>

                      <div class="hr-line-dashed"></div>

                      <div class="row">
                        <div class="col-sm-2">
                          <label class="control-label required" for="anexouDocumentos">Anexou a CERT</label>

                          <div class="form-group required">
                            <radio v-model="solicitacao.solicitacaoAnexouArquivo"
                                   selected-value="true"
                                   type="success"
                                   :inline="true"
                                   class="margin-right-10"
                                   :class="[true ? '' : 'radioLeft']">
                              Sim
                            </radio>
                            <radio v-model="solicitacao.solicitacaoAnexouArquivo"
                                   selected-value="false"
                                   data-vv-name="anexouDocumentos"
                                   type="success"
                                   :inline="true">
                              Não
                            </radio>
                          </div>
                        </div>
                        
                        <div class="col-sm-10" v-if="solicitacao.solicitacaoAnexouArquivo == 'false'">
                          <label class="control-label required" for="justificativa">Informe o motivo pelo qual o documento não foi anexado</label>

                          <div class="form-group required" :class="{'has-error': errors.has('justificativa')}">

                            <input type="text"
                                   class="form-control"
                                   id="justificativa"
                                   v-model="solicitacao.solicitacaoJustificativaAnexo"
                                   data-vv-name="justificativa"
                                   data-vv-as="Justificativa"
                                   v-validate="'required'">

                            <p class="text-danger" v-show="errors.has('justificativa')">{{ errors.first('justificativa') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane" v-if="usarEstruturaArquivoAntiga">
                <div class="panel-body">                 
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>                  
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane" v-if="usarEstruturaArquivoAntiga">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">CPF</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="cpf"
                   data-vv-name="documento"
                   v-mascara="'cpf'"
                   v-validate="'required|cpf'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'solicitacao-bolsa' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="avancar"
                    type="button"
                    class="btn btn-primary"
                    @click="validarBeneficiario"
                    v-show="!mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button type="button"
                    class="btn btn-default"
                    @click="mostrarFormulario = false, resetarComponente()"
                    v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/SolicitacaoBolsaForm.vue